import { render, staticRenderFns } from "./ScreenFichaEstudiante.vue?vue&type=template&id=691eadc6"
import script from "./ScreenFichaEstudiante.vue?vue&type=script&lang=js"
export * from "./ScreenFichaEstudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports